module.exports = __webpack_public_path__ + "static/img/bg_business_h4.96fb753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/bg_business_h4.png
// module id = oH60
// module chunks = 3